<template>
  <b-card
    class="plano-lista-item"
    header-class="bg-white border-0"
    footer-class="bg-white"
  >
    <template #header>
      <card-header
        :show-status="false"
        :label="strategic_plan.name"
        :icon="plan_icon"
        :caption-top="formatedCaption"
        label-class="h6 pr-5"
      />
    </template>
    <b-card-text class="text-muted text-body1">{{ description }}</b-card-text>

    <div class="plan-labels mt-3">
      <div class="plan-label-item">
        <span class="plan-label-title">Progresso</span>
        <div class="plan-label-bar-wrap">
          <div class="plan-label-bar">
            <div
              class="plan-label-bar-fill"
              :class="completudeBarClass"
              :style="{ width: completudePct + '%' }"
            />
          </div>
          <span class="plan-label-bar-text">{{ completudeTexto }}</span>
        </div>
      </div>
      <div class="plan-label-item">
        <span class="plan-label-title">Cronograma</span>
        <span class="plan-label-badge" :class="cronogramaClass">
          {{ cronogramaTexto }}
        </span>
      </div>
      <div class="plan-label-item">
        <span class="plan-label-title">Orçamento</span>
        <span class="plan-label-badge" :class="orcamentoClass">
          {{ orcamentoTexto }}
        </span>
      </div>
    </div>

    <template #footer>
      <b-row no-gutters align-v="end" class="my-2">
        <b-col>
          <b-card-text class="text-muted text-caption2">
            Visualizar detalhes do plano
          </b-card-text>
        </b-col>
        <b-col sm="auto">
          <b-link
            class="py-2 px-3 link-button text-decoration-none text-body1"
            :to="formatedLink"
          >
            Acessar plano <b-icon icon="chevron-right" />
          </b-link>
        </b-col>
      </b-row>
    </template>
  </b-card>
</template>

<script>
import CardHeader from "@/components/Home/Card/CardHeader.vue";

export default {
  props: {
    strategic_plan: {
      type: Object,
      required: true
    }
  },
  components: {
    CardHeader
  },
  data: () => ({}),
  computed: {
    plan_icon() {
      if (this.strategic_plan.icon) {
        var icon = this.strategic_plan.icon.split(" ");
        if (icon.length > 1) {
          return icon;
        } else {
          return this.strategic_plan.icon;
        }
      }
      return false;
    },
    description() {
      return this.strategic_plan.description
        ? this.strategic_plan.description.substring(0, 240) + "..."
        : "";
    },
    formatedCaption() {
      const startDate = this.strategic_plan.start_term;
      const endDate = this.strategic_plan.end_term;
      const formatedStartDate = this.$options.filters.format_date(startDate);
      const formatedEndDate = this.$options.filters.format_date(endDate);
      return `De ${formatedStartDate} a ${formatedEndDate}`;
    },
    formatedLink() {
      const id = this.strategic_plan.id;
      return {
        name: "strategic_plans_show",
        params: { id }
      };
    },
    completudePct() {
      const total = Number(this.strategic_plan.total_acoes) || 0;
      const done = Number(this.strategic_plan.total_acoes_finalizadas) || 0;
      return total > 0 ? Math.round((done / total) * 100) : 0;
    },
    completudeTexto() {
      const total = Number(this.strategic_plan.total_acoes) || 0;
      const done = Number(this.strategic_plan.total_acoes_finalizadas) || 0;
      return `${done}/${total} (${this.completudePct}%)`;
    },
    completudeBarClass() {
      const total = Number(this.strategic_plan.total_acoes) || 0;
      const done = Number(this.strategic_plan.total_acoes_finalizadas) || 0;
      if (total === 0 || done === 0) return "bar-neutral";
      if (this.completudePct >= 100) return "bar-success";
      return "bar-completude-progress";
    },
    cronogramaTexto() {
      return this.strategic_plan.prazo?.status || "Sem cronograma";
    },
    cronogramaClass() {
      const s = this.cronogramaTexto.toLowerCase();
      if (s.includes("atras")) return "badge-danger";
      if (s.includes("prazo") || s.includes("on time")) return "badge-success";
      return "badge-neutral";
    },
    orcamentoTexto() {
      return this.strategic_plan.orcamento || "Sem orçamento";
    },
    orcamentoClass() {
      const s = this.orcamentoTexto.toLowerCase();
      if (s.includes("excedeu")) return "badge-danger";
      if (s.includes("dentro")) return "badge-success";
      return "badge-neutral";
    }
  }
};
</script>

<style lang="scss">
.plano-lista-item h5,
.plano-lista-item h6 {
  max-width: 82%;
}

.link-button {
  border-radius: 6px !important;
  a {
    color: var(--secondary) !important;
  }

  &:hover {
    background: rgba(var(--primary-rgb), 0.1);
    a {
      color: var(--primary) !important;
    }
  }
}

.plan-labels {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.plan-label-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
}

.plan-label-title {
  font-size: 0.75rem;
  font-weight: 600;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  white-space: nowrap;
  flex-shrink: 0;
}

.plan-label-bar-wrap {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex: 1;
  min-width: 0;
}

.plan-label-bar {
  height: 0.375rem;
  flex: 1;
  border-radius: 9999px;
  background: rgba(0, 0, 0, 0.08);
  overflow: hidden;
}

.plan-label-bar-fill {
  height: 100%;
  border-radius: 9999px;
  transition: width 0.4s ease;
}

.bar-success {
  background: #10b981;
}

.bar-completude-progress {
  background: #2563eb;
}

.bar-danger {
  background: #ef4444;
}

.bar-neutral {
  background: #9ca3af;
}

.plan-label-bar-text {
  font-size: 0.75rem;
  font-weight: 500;
  color: #6b7280;
  white-space: nowrap;
  flex-shrink: 0;
}

.plan-label-badge {
  display: inline-flex;
  align-items: center;
  padding: 0.125rem 0.5rem;
  border-radius: 9999px;
  font-size: 0.6875rem;
  font-weight: 500;
  white-space: nowrap;
}

.badge-success {
  background: #d1fae5;
  color: #065f46;
}

.badge-danger {
  background: #fee2e2;
  color: #991b1b;
}

.badge-neutral {
  background: #f3f4f6;
  color: #6b7280;
}
</style>
